import { useTranslation } from 'react-i18next';
import { CheckCircle2, CloudOff, Loader2, AlertTriangle, Cloud } from 'lucide-react';

import { useAuthStore } from '@/stores/authStore';
import { useSettingsStore } from '@/stores/settingsStore';

export function SyncStatus() {
  const { t } = useTranslation();
  const syncEnabled = useSettingsStore((s) => s.syncEnabled);
  const status = useAuthStore((s) => s.syncStatus);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const error = useAuthStore((s) => s.syncError);

  if (!syncEnabled) return null;

  if (!isAuthenticated) {
    return (
      <span className="flex items-center gap-1 text-xs text-muted-foreground">
        <CloudOff className="h-3 w-3" />
        {t('sync.notSignedIn')}
      </span>
    );
  }

  if (status === 'syncing') {
    return (
      <span className="flex items-center gap-1 text-xs text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" />
        {t('sync.syncing')}
      </span>
    );
  }

  if (status === 'error') {
    return (
      <span className="flex items-center gap-1 text-xs text-destructive" title={error ?? ''}>
        <AlertTriangle className="h-3 w-3" />
        {t('sync.error')}
      </span>
    );
  }

  if (status === 'offline') {
    return (
      <span className="flex items-center gap-1 text-xs text-muted-foreground">
        <CloudOff className="h-3 w-3" />
        {t('sync.offline')}
      </span>
    );
  }

  if (status === 'synced') {
    return (
      <span className="flex items-center gap-1 text-xs text-emerald-600">
        <CheckCircle2 className="h-3 w-3" />
        {t('sync.synced')}
      </span>
    );
  }

  return (
    <span className="flex items-center gap-1 text-xs text-muted-foreground">
      <Cloud className="h-3 w-3" />
      {t('sync.idle')}
    </span>
  );
}
